import { render, staticRenderFns } from "./post-list.vue?vue&type=template&id=a79712aa&scoped=true"
import script from "./post-list.vue?vue&type=script&lang=js"
export * from "./post-list.vue?vue&type=script&lang=js"
import style0 from "./post-list.vue?vue&type=style&index=0&id=a79712aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79712aa",
  null
  
)

export default component.exports